import React, { useEffect, useState } from 'react';
import { Pagination, Form } from 'react-bootstrap';

const PAGE_SIZE_OPTIONS = [25, 50, 100, 1000];
const DEFAULT_PAGE_SIZE = 25;
const pageLinksToShow = 15;
const ITEMS_PER_PAGE_KEY = 'itemsPerPage';

const PaginationComponent = ({ 
    currentPage, 
    totalItems, 
    onPageChange,
    onItemsPerPageChange = () => {} // This is used just to notify about changes
}) => {
    // Initialize state with localStorage value
    const [itemsPerPage, setItemsPerPage] = useState(() => {
        const stored = localStorage.getItem(ITEMS_PER_PAGE_KEY);
        return stored ? parseInt(stored) : DEFAULT_PAGE_SIZE;
    });

    const totalPageCount = Math.ceil(totalItems / itemsPerPage);

    // Save to localStorage whenever itemsPerPage changes
    useEffect(() => {
        localStorage.setItem(ITEMS_PER_PAGE_KEY, itemsPerPage.toString());
        onItemsPerPageChange(itemsPerPage); // Notify parent about the change
    }, [itemsPerPage, onItemsPerPageChange]);

    const getPaginationItems = () => {
        const items = [];
        const startPage = Math.max(1, currentPage - pageLinksToShow);
        const endPage = Math.min(totalPageCount, currentPage + pageLinksToShow);

        for (let page = startPage; page <= endPage; page++) {
            items.push(
                <Pagination.Item 
                    key={page} 
                    active={page === currentPage} 
                    onClick={() => onPageChange(page)}
                >
                    {page}
                </Pagination.Item>
            );
        }
        return items;
    };

    return (
        <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-3">
                <Form.Select 
                    className="w-auto"
                    value={itemsPerPage}
                    onChange={(e) => {
                        const newValue = Number(e.target.value);
                        setItemsPerPage(newValue);
                        onPageChange(1);
                    }}
                >
                    {PAGE_SIZE_OPTIONS.map(size => (
                        <option key={size} value={size}>
                            {size} items per page
                        </option>
                    ))}
                </Form.Select>
                <span className="text-muted">
                    Total: {totalItems} items
                </span>
            </div>
            <Pagination className="mb-0">
                <Pagination.Prev 
                    onClick={() => onPageChange(currentPage - 1)} 
                    disabled={currentPage === 1}
                />
                {getPaginationItems()}
                <Pagination.Next 
                    onClick={() => onPageChange(currentPage + 1)} 
                    disabled={currentPage === totalPageCount}
                />
            </Pagination>
        </div>
    );
};

// Export a helper function to get the current items per page
PaginationComponent.getCurrentPageSize = () => {
    const stored = localStorage.getItem(ITEMS_PER_PAGE_KEY);
    const value = stored ? parseInt(stored) : DEFAULT_PAGE_SIZE;
    
    // Ensure the value is saved in localStorage if it wasn't there
    if (!stored) {
        localStorage.setItem(ITEMS_PER_PAGE_KEY, value.toString());
    }
    
    return value;
};

export default PaginationComponent; 